var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-spacer", attrs: { id: "tip" } },
    [
      _c("ViewHeader", { attrs: { title: "Add Tip" } }),
      _c(
        "div",
        { staticClass: "drop-shadow-sides", attrs: { id: "rest-of-body" } },
        [
          _c("div", { attrs: { id: "total" } }, [
            _c("table", [
              _c("tr", [
                _c("td", { staticClass: "label-column" }, [_vm._v("Total")]),
                _c("td", { staticClass: "value-column" }, [
                  _vm._v(_vm._s(_vm._f("toCurrency")(_vm.total))),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "label-column" }, [_vm._v("Tip")]),
                _c(
                  "td",
                  { staticClass: "value-column" },
                  [
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: _vm.readyForAnimation ? "amount-drop-in" : "",
                          mode: "out-in",
                        },
                      },
                      [
                        _c("div", { key: _vm.enteredTip }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("toCurrency")(_vm.enteredTip)) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            { attrs: { id: "actions" } },
            [
              _c(
                "button",
                {
                  staticClass: "button-secondary",
                  class: {
                    "button-secondary-selected": _vm.selected === "18-pct-tip",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.select("18-pct-tip")
                    },
                  },
                },
                [_vm._v(" 18% ")]
              ),
              _c(
                "button",
                {
                  staticClass: "button-secondary",
                  class: {
                    "button-secondary-selected": _vm.selected === "20-pct-tip",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.select("20-pct-tip")
                    },
                  },
                },
                [_vm._v(" 20% ")]
              ),
              _c(
                "button",
                {
                  staticClass: "button-secondary",
                  class: {
                    "button-secondary-selected": _vm.selected === "25-pct-tip",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.select("25-pct-tip")
                    },
                  },
                },
                [_vm._v(" 25% ")]
              ),
              _vm.isOtherPctTipInputVisible
                ? _c(
                    "Money",
                    _vm._b(
                      {
                        directives: [{ name: "focus", rawName: "v-focus" }],
                        class: _vm.otherPctTipClass,
                        nativeOn: {
                          blur: function ($event) {
                            return _vm.setOtherPctTip.apply(null, arguments)
                          },
                          input: function ($event) {
                            return _vm.scrubNumberInput.apply(null, arguments)
                          },
                          keyup: function ($event) {
                            return _vm.validateAndSetOtherPctTipOnEnter.apply(
                              null,
                              arguments
                            )
                          },
                        },
                        model: {
                          value: _vm.formattedOtherPctTip,
                          callback: function ($$v) {
                            _vm.formattedOtherPctTip = $$v
                          },
                          expression: "formattedOtherPctTip",
                        },
                      },
                      "Money",
                      _vm.percentage,
                      false
                    )
                  )
                : _c(
                    "button",
                    {
                      staticClass: "button-secondary",
                      class: {
                        "button-secondary-selected":
                          _vm.selected === "other-pct-tip",
                      },
                      on: { click: _vm.editOtherPctTip },
                    },
                    [
                      _vm.otherPctTip > 0
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("toFormattedNumber")(_vm.otherPctTip, 0)
                              ) + "%"
                            ),
                          ])
                        : _c("span", [_vm._v("Other %")]),
                    ]
                  ),
              _vm.isDollarTipInputVisible
                ? _c(
                    "Money",
                    _vm._b(
                      {
                        directives: [{ name: "focus", rawName: "v-focus" }],
                        class: _vm.dollarTipClass,
                        nativeOn: {
                          blur: function ($event) {
                            return _vm.setDollarTip.apply(null, arguments)
                          },
                          input: function ($event) {
                            return _vm.scrubNumberInput.apply(null, arguments)
                          },
                          keyup: function ($event) {
                            return _vm.validateAndSetDollarTipOnEnter.apply(
                              null,
                              arguments
                            )
                          },
                        },
                        model: {
                          value: _vm.formattedDollarTip,
                          callback: function ($$v) {
                            _vm.formattedDollarTip = $$v
                          },
                          expression: "formattedDollarTip",
                        },
                      },
                      "Money",
                      _vm.money,
                      false
                    )
                  )
                : _c(
                    "button",
                    {
                      staticClass: "button-secondary",
                      class: {
                        "button-secondary-selected":
                          _vm.selected === "dollar-tip",
                      },
                      on: { click: _vm.editDollarTip },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("toCurrency")(
                              _vm.dollarTip > 0 ? _vm.dollarTip : "$"
                            )
                          ) +
                          " Tip "
                      ),
                    ]
                  ),
              _c(
                "button",
                {
                  staticClass: "button-secondary",
                  class: {
                    "button-secondary-selected": _vm.selected === "no-tip",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.select("no-tip")
                    },
                  },
                },
                [_vm._v(" No Tip ")]
              ),
              _c(
                "button",
                {
                  staticClass: "button-primary",
                  attrs: { disabled: _vm.isConfirmDisabled },
                  on: { click: _vm.commitTip },
                },
                [_vm._v(" Confirm ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }